import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./premiumAccessSliceInitialState";
import {
  grantPremiumAccessAction,
  revokePremiumAccessAction,
} from "./premiumAccessSliceActions";

export const premiumAccessSlice = createSlice({
  name: "premiumAccess",
  initialState,
  reducers: {
    clearPremiumAccessMessages: (state) => {
      state.grantPremiumSuccess = null;
      state.revokePremiumSuccess = null;
      state.error = null;
    },
    clearPremiumAccessError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Grant Premium Access
      .addCase(grantPremiumAccessAction.pending, (state) => {
        state.isGrantingPremium = true;
        state.error = null;
        state.grantPremiumSuccess = null;
      })
      .addCase(grantPremiumAccessAction.fulfilled, (state, action) => {
        state.isGrantingPremium = false;
        state.grantPremiumSuccess = action.payload;
        state.error = null;
      })
      .addCase(grantPremiumAccessAction.rejected, (state, action) => {
        state.isGrantingPremium = false;
        state.error = action.payload || "Failed to grant premium access";
        state.grantPremiumSuccess = null;
      })
      // Revoke Premium Access
      .addCase(revokePremiumAccessAction.pending, (state) => {
        state.isRevokingPremium = true;
        state.error = null;
        state.revokePremiumSuccess = null;
      })
      .addCase(revokePremiumAccessAction.fulfilled, (state, action) => {
        state.isRevokingPremium = false;
        state.revokePremiumSuccess = action.payload;
        state.error = null;
      })
      .addCase(revokePremiumAccessAction.rejected, (state, action) => {
        state.isRevokingPremium = false;
        state.error = action.payload || "Failed to revoke premium access";
        state.revokePremiumSuccess = null;
      });
  },
});

export const { clearPremiumAccessMessages, clearPremiumAccessError } =
  premiumAccessSlice.actions;

export default premiumAccessSlice.reducer;
